/**
 * Created by contrapro on 03/04/2018
 */

import { HOST_ENV } from '../cfg';

//lean:
const API_HOST_DEV = 'http://10.0.0.7:3000';
const API_HOST_TEST = 'https://k11syall-test.leanapp.cn';
const API_HOST_PROD = 'https://k11syl1-test.leanapp.cn';//这个是对的，正式服是原来的l1测试服

export function getWebHost() {
    //TODO
    // return WEB_HOST_STG;

    if (HOST_ENV === 'development') {
        return API_HOST_DEV;
    }

    if (HOST_ENV === 'staging') {
        return API_HOST_TEST;
    }

    if (HOST_ENV === 'testing') {
        return API_HOST_TEST;
    }

    if (HOST_ENV === 'production') {
        return API_HOST_PROD;
    }

    // alert('a', HOST_ENV);
    return API_HOST_TEST;
}

//TODO: 要换成K11的
export function getJSSDKSignConfigHost() {
    // return 'https://wx.intplusplus.com/wechat/jssdk/getsign.php?gzh=dyh';
    return getWebHost() + '/crmtest/jssdk';
    // return (HOST_ENV === 'production') ?
    //     getWebHost() + '/crmtest/jssdk'
    //     : 'https://wx.intplusplus.com/wechat/jssdk/getsign.php?gzh=dyh';
}

const STATIC_HOST_DEV = 'http://localhost:3002';
const STATIC_HOST_TEST = 'https://k11syl31.intplusplus.net';
export const STATIC_HOST_PROD = 'https://k11syl31-v.klub11.com';

export function getStaticHost() {
    // console.log('get static host', window.location.origin);
    // alert(window.location.origin);
    //貌似可以直接返回origin，为了保险向前兼容，对新域名做特殊处理
    // if (window.location.origin === 'https://cdn-city-vendor.klub11.com') {
    return window.location.origin;
    // }

    if (HOST_ENV === 'development') {
        return STATIC_HOST_DEV;
    }

    return window.location.origin;

    if (HOST_ENV === 'testing') {
        return STATIC_HOST_TEST;
    }

    if (HOST_ENV === 'staging') {
        return STATIC_HOST_TEST;
    }

    if (HOST_ENV === 'production') {
        return STATIC_HOST_PROD;
    }

    // alert('b', HOST_ENV);
    return STATIC_HOST_TEST;
}

export function getMallID() {
    if (process.env.NODE_ENV === 'development') {
        return 'GZ01';
    }

    if (HOST_ENV === 'staging') {
        return 'GZ01';
    }

    if (HOST_ENV === 'production') {
        return 'SY01';
    }

    return 'GZ01';
}


// WEBPACK FOOTER //
// ./src/util/serverUtil.js